import { Container, SimpleGrid, Card, Image, Text, Stack } from '@mantine/core';

interface Book {
    title: string;
    author: string;
    coverImage: string;
}

const books: Book[] = [
    {
        title: "The World for Sale: Money, Power and the Traders Who Barter the Earth's Resources",
        author: "Javier Blas",
        coverImage: "https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1616664353i/52199304.jpg"
    },
    {
        title: "Cobalt Red: How the Blood of the Congo Powers Our Lives",
        author: "Siddharth Kara",
        coverImage: "https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1666032360i/60784614.jpg"
    },
    {
        title: "River of Darkness: Francisco Orellana's Legendary Voyage of Death and Discovery Down the Amazon",
        author: "Buddy Levy",
        coverImage: "https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1320390342i/9152282.jpg"
    },
    {
        title: "As a Man Thinketh",
        author: "James Allen",
        coverImage: "https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1632020500i/81959.jpg"
    },
    {
        title: "Zero to One: Notes on Startups, or How to Build the Future",
        author: "Peter Thiel",
        coverImage: "https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1630663027i/18050143.jpg"
    },
    {
        title: "The Brothers Karamazov",
        author: "Fyodor Dostoevsky",
        coverImage: "https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1427728126i/4934.jpg"
    },
    {
        title: "Hillbilly Elegy: A Memoir of a Family and Culture in Crisis",
        author: "J.D. Vance",
        coverImage: "https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1463569814i/27161156.jpg"
    },
    {
        title: "King Rat",
        author: "James Clavell",
        coverImage: "https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1388889819i/9827.jpg"
    },
    {
        title: "Streets of Laredo",
        author: "Larry McMurtry",
        coverImage: "https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1371294481i/54812.jpg"
    },
    {
        title: "Comanche Moon",
        author: "Larry McMurtry",
        coverImage: "https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1728661160i/54807.jpg"
    },
    {
        title: "Dead Man's Walk",
        author: "Larry McMurtry",
        coverImage: "https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1371294566i/54804.jpg"
    },
    {
        title: "Lonesome Dove",
        author: "Larry McMurtry",
        coverImage: "https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1559668037i/256008.jpg"
    },
    {
        title: "2010: Odyssey Two",
        author: "Arthur C. Clarke",
        coverImage: "https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1388271989i/70539.jpg"
    },
    {
        title: "2001: A Space Odyssey",
        author: "Arthur C. Clarke",
        coverImage: "https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1432468943i/70535.jpg"
    },
    {
        title: "Farther Than Any Man: The Rise and Fall of Captain James Cook",
        author: "Martin Dugard",
        coverImage: "https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1263426659i/4767164.jpg"
    },
    {
        title: "Skeletons on the Zahara: A True Story of Survival",
        author: "Dean King",
        coverImage: "https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1442027487i/408147.jpg"
    },
    {
        title: "My Life and Work: Autobiography of Henry Ford",
        author: "Henry Ford",
        coverImage: "https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1677820263i/31016205.jpg"
    },
    {
        title: "The Metamorphosis",
        author: "Franz Kafka",
        coverImage: "https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1646444605i/485894.jpg"
    }
];

export default function Books() {
    return (
        <Container size="xl" py="xl">
            <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="lg">
                {books.map((book, index) => (
                    <Card key={index} shadow="sm" padding="lg" radius="md" withBorder>
                        <Card.Section>
                            <Image
                                src={book.coverImage}
                                height={500}
                                alt={`Book Cover: ${book.title}`}
                            />
                        </Card.Section>

                        <Stack mt="md" mb="xs">
                            <Text fw={500} size="lg">{book.title}</Text>
                            <Text size="sm" c="dimmed">
                                {book.author}
                            </Text>
                        </Stack>
                    </Card>
                ))}
            </SimpleGrid>
        </Container>
    );
} 